import { Capacitor } from '@capacitor/core'
import { Preferences } from '@capacitor/preferences'

const SESSION_KEY = 'mw_bff_session_id'

export function useBffSession() {
  const isCapacitor = Capacitor.isNativePlatform()

  async function setSessionId(sessionId: string): Promise<void> {
    if (!isCapacitor) {
      return
    }

    try {
      await Preferences.set({
        key: SESSION_KEY,
        value: sessionId,
      })
    } catch (error) {
      console.error('[useBffSession] Failed to store BFF session id', error)
      throw error
    }
  }

  async function getSessionId(): Promise<string | null> {
    if (!isCapacitor) {
      return null
    }

    try {
      const { value } = await Preferences.get({ key: SESSION_KEY })
      return value ?? null
    } catch (error) {
      console.error('[useBffSession] Failed to read BFF session id', error)
      return null
    }
  }

  async function clearSession(): Promise<void> {
    if (!isCapacitor) {
      return
    }

    try {
      await Preferences.remove({ key: SESSION_KEY })
    } catch (error) {
      console.error('[useBffSession] Failed to clear BFF session id', error)
    }
  }

  return {
    isCapacitor,
    setSessionId,
    getSessionId,
    clearSession,
  }
}

